import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/Home.vue'
import Login from '../components/Login.vue'
// import Menu from '../components/main/Menu.vue'
import MyUserList from '../components/main/MyUserList.vue'
import MyMenu from '../components/main/MyMenu.vue'
import Users from '../components/main/users/Users.vue'
import Groups from '../components/main/groups/Groups.vue'
import Main from '../components/main/Main.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    component: Home
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/Main',
    component: Main,
    children: [
      {
        path: '/list',
        component: MyUserList
      },
      {
        path: '/mainmenu',
        component: MyMenu
      },
      {
        path: '/users',
        component: Users
      },
      {
        path: '/groups',
        component: Groups
      },
      {
        path: '/',
        redirect: '/groups'
      }

    ]
  }
]

const router = new VueRouter({
  routes
})

export default router
